import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-battle-reduce",
  "use": "icon-battle-reduce-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-battle-reduce\"><path d=\"M170.666667 469.333333h682.666666v85.333334H170.666667z\" fill=\"#A6ABB8\" p-id=\"7711\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol